define('app/factories/all',[
  'app/setup',
  './newsletter_popup_factory',
  './newsletter_vendor_factory',
  './newsletter_footer_factory',
  './newsletter_finished_factory',
  './address_form_factory',
  './tab_factory',
  './minicart_factory',
  './top_banner_factory',
  './product_image_slider_factory',
  './discount_coupons_image_slider_factory',
  './deal_page_slider_factory',
  './gift_message_form_factory',
  './gift_message_factory',
  './overlay_factory',
  './search_results_factory',
  './search_suggestion_factory',
  './message_factory',
  './customer_register_success_factory',
  './cart_customer_credit_factory',
  './customer_profile_factory',
  './checkout_onepage_top_nav_factory',
  './tab_factory',
  './forgot_password_factory',
  './organization_login_factory',
  './modal_factory',
  './_cms_business_page_factory',
  './business_contact_form_factory',
  './ga_product_impression_helper',
  './lazy_factory',
  './lazy_single_factory',
  './login_links_factory',
  './question_ask_factory',
  // './navigation_factory',
  './sale_factory',
  './register_form_social_factory',
  './_b2b_landing_page_factory',
  './_event_products_factory',
  './scheme_url_redirect_factory',
  './b2b_contact_form_factory',
  './enamad_factory',
  './product_category_single_page_factory',
  './reset_password_factory',
  './guest_checkout_user_info_factory',
  './guest_checkout_user_address_info_factory',
  './guest_success_register_form_factory',
  './payment_factory',
  './checkout_login_container_factory',
  './checkout_login_form_factory',
  './checkout_shipping_container_factory',
  './checkout_guest_register_form',
  './product_sub_category_single_page_factory',
  './reset_password_factory',
  './newsletter_mobile_subscription_box_factory',
  './tracker_factory',
  './scheduled_deals_factory',
  // './special_event_box_factory',
  //  './emarsys_tracking_factory',
  './double_optin_confirm_factory',
  './dc_deal_toolkit_factory',
  './vendor_factory',
  './vendor_deal_req_factory',
  './cart_submit_button_factory',
  './tags_factory',
  './cities_factory',
  './special_discount_factory',
  './support_24_7_factory',
  './location_map_factory',
  './location_categories_list_factory',
  './location_deals_list_factory',
  './owl_factory',
  './carousel_factory',
  './grid_resizer_factory',
  './yadisa_sale_factory',
  './yadisa_comment_section_factory',
  './scroll_to_anchor',
  './location_city_select_zone',
  './yadisa_checkout',
  './yadisa_product_modal',
  './vendor_rating_factory',
  './timers_factory',
  './subcategories_section_factory',
  './simple_tab_view',
  './simple_slider',
  './simple_show_more',
  './show_more_deals_factory',
  './show_more_coupons_factory',
  './rating_sort_deals_factory',
  './kala_promo_factory',
  './kala_featured_list_factory',
  './interest_tracker_factory',
  './travel_search_factory',
  './mighty_slider_carousel_factory',
  './fix_sidebar_factory',
  './tooltip_factory',
  './ajax_form_factory',
  './tooltip_factory',
  './tickets_passengers_info_factory',
  './fix_sidebar_custom_factory',
  './class_toggle_factory',
  './dc_category_filter_factory',
  './dc_deal_filter_factory',
  './on_map_factory',
  './dc_subscribe_box_factory',
  './report_product_view_factory',
  './vendor_rating_form_factory',
  './travel_hotel_factory',
  './checkout_page_factory',
  './travel_hotel_factory',
  './deal_vendor_phone_number_factory',
  './home_travel_widget_factory',
  './dashboard_coupon_list_factory',
], function(){});

